module.exports = __webpack_public_path__ + "static/img/pageBg1.ce637c8b.png";